import { Injectable, inject } from '@angular/core';
// import {Actions, Effect, ofType} from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
	ActionTypes, DisLikeStudio,
	GetStudios,
	GetStudiosError, GetStudiosSilently,
	GetStudiosSuccess, LikeStudio,
	LikeStudioError,
	LikeStudioSuccess, PostComment, PostCommentError, PostCommentSuccess
} from "./studio.actions";
import { Helper } from "../../shared/services/Helper.service";
import { StudioService } from "../../shared/services/studio.service";

@Injectable()
export class StudioEffects {

	// @Effect()
	// GetStudiosSilently$ = this.actions$.pipe(
	GetStudiosSilently$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStudiosSilently),
			map((action: GetStudiosSilently) => action.payload),
			mergeMap((payload) => {
				return this.studioService.GetStudios(payload).pipe(
					map((response) => {
						return new GetStudiosSuccess(response)
					}),
					catchError((error) => of(new GetStudiosError(error))))
			})
		)
	});
	// );

	// @Effect()
	// GetStudios$ = this.actions$.pipe(
	GetStudios$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStudios),
			map((action: GetStudios) => action.payload),
			mergeMap((payload) => {
				return this.studioService.GetStudios(payload).pipe(
					map((response) => {
						return new GetStudiosSuccess(response)
					}),
					catchError((error) => of(new GetStudiosError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetStudiosSuccess$ = this.actions$.pipe(
	GetStudiosSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStudiosSuccess),
			map((action: GetStudiosSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetStudiosError$ = this.actions$.pipe(
	GetStudiosError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStudiosError),
			map((action: GetStudiosError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );


	// @Effect()
	// DisLikeStudio$ = this.actions$.pipe(
	DisLikeStudio$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DisLikeStudio),
			map((action: DisLikeStudio) => action.payload),
			mergeMap((payload) => {
				return this.studioService.DisLikeStudio(payload.studioId, payload.likeId).pipe(
					map((response) => {
						return new LikeStudioSuccess(response)
					}),
					catchError((error) => of(new LikeStudioError(error))))
			})
		)
	});
	// );

	// @Effect()
	// LikeStudio$ = this.actions$.pipe(
	LikeStudio$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.LikeStudio),
			map((action: LikeStudio) => action.payload),
			mergeMap((payload) => {
				return this.studioService.LikeStudio(payload.studioId).pipe(
					map((response) => {
						return new LikeStudioSuccess(response)
					}),
					catchError((error) => of(new LikeStudioError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// LikeStudioSuccess$ = this.actions$.pipe(
	LikeStudioSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.LikeStudioSuccess),
			map((action: LikeStudioSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// LikeStudioError$ = this.actions$.pipe(
	LikeStudioError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.LikeStudioError),
			map((action: LikeStudioError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// PostComment$ = this.actions$.pipe(
	PostComment$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.PostComment),
			map((action: PostComment) => action.payload),
			mergeMap((payload) => {
				return this.studioService.PostComment(payload.studioId, payload.commentPayload).pipe(
					map((response) => {
						return new PostCommentSuccess(response)
					}),
					catchError((error) => of(new PostCommentError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// PostCommentSuccess$ = this.actions$.pipe(
	PostCommentSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.PostCommentSuccess),
			map((action: PostCommentSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// PostCommentError$ = this.actions$.pipe(
	PostCommentError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.PostCommentError),
			map((action: PostCommentError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	constructor(
		private actions$: Actions,
		private helper: Helper,
		private studioService: StudioService,
	) {
	}
}
